module.exports = __webpack_public_path__ + "img/technic.020c962b.png";